import React from 'react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { RefreshCw } from 'lucide-react';
import { StatusPill } from './PricingShared';

const JobsTab = ({ liveJobs, onRefresh }) => {
  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-4 mb-6">
        {[
          { label: 'Revenue', value: `$${liveJobs.kpis.revenue || 0}` },
          { label: 'Cost', value: `$${liveJobs.kpis.cost || 0}` },
          { label: 'Profit', value: `$${liveJobs.kpis.profit || 0}` },
          { label: 'Margin', value: `${liveJobs.kpis.margin || 0}%` },
          { label: 'Hours', value: liveJobs.kpis.hours || 0 },
          { label: '$/Hour', value: `$${liveJobs.kpis.profit_per_hour || 0}` },
        ].map((kpi, i) => (
          <Card key={i} className="p-4 text-center" data-testid={`live-kpi-${i}`}>
            <p className="text-2xl font-bold">{kpi.value}</p>
            <p className="text-xs text-gray-500">{kpi.label}</p>
          </Card>
        ))}
      </div>

      <Card className="border-gray-200 bg-white">
        <div className="p-4 border-b flex justify-between items-center">
          <h3 className="font-bold">Today's Jobs</h3>
          <Button variant="outline" size="sm" onClick={onRefresh} data-testid="refresh-jobs-btn">
            <RefreshCw className="h-4 w-4 mr-2" />Refresh
          </Button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full" data-testid="live-jobs-table">
            <thead>
              <tr className="border-b bg-gray-50 text-left text-sm text-gray-500">
                <th className="py-3 px-4">Booking ID</th>
                <th className="py-3 px-4">Vehicle</th>
                <th className="py-3 px-4">Service</th>
                <th className="py-3 px-4">Hours</th>
                <th className="py-3 px-4">Revenue</th>
                <th className="py-3 px-4">Profit</th>
                <th className="py-3 px-4">Margin</th>
                <th className="py-3 px-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {(liveJobs.jobs || []).map((job, i) => (
                <tr key={i} className="border-b hover:bg-gray-50">
                  <td className="py-3 px-4 text-sm font-mono">{job.booking_id}</td>
                  <td className="py-3 px-4 text-sm">{job.vehicle_name}</td>
                  <td className="py-3 px-4 text-sm capitalize">{job.service_type}</td>
                  <td className="py-3 px-4 text-sm">{job.hours}</td>
                  <td className="py-3 px-4 text-sm font-medium">${job.revenue_total || 0}</td>
                  <td className="py-3 px-4 text-sm font-medium">${job.profit_after_driver || 0}</td>
                  <td className="py-3 px-4 text-sm">{job.margin_percent || 0}%</td>
                  <td className="py-3 px-4"><StatusPill status={job.status || 'green'} /></td>
                </tr>
              ))}
              {(!liveJobs.jobs || liveJobs.jobs.length === 0) && (
                <tr><td colSpan={8} className="py-12 text-center text-gray-400">No jobs scheduled for today. Add bookings with today's date to see them here.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </>
  );
};

export default JobsTab;
